import React from 'react';
import PropTypes from 'prop-types';

import { TooltipBanner } from 'components/core/TooltipBanner';
import ExpressIcon from 'components/svg/ExpressIcon';

export function ExpressBanner({ last }) {
	const tooltipContent =
		'Check into this facility online, eliminating the' +
		' need to fill out rental paperwork at the facility when you plan to move in.';
	return (
		<TooltipBanner
			tooltipContent={tooltipContent}
			bannerText="Online Move-In Available"
			textColor="darkGray"
			bannerIcon={<ExpressIcon />}
			theme="orange"
			last={last}
		/>
	);
}

ExpressBanner.propTypes = {
	last: PropTypes.bool,
};

export default ExpressBanner;
